import { keyframes, styled } from '@mui/material/styles'

const floatAndFade = keyframes`
  0% {
    opacity: 1;
    top: 0px;
    scale: 1;
  }
  50% {
    opacity: 1;
    top: -8px;
    scale: 1.2;
    rotate: -3deg;
  }
  100% {
    opacity: 0;
    top: -15px;
    scale: 1.33;
    rotate: -5deg;
  }
`

const FloatingText = styled('div')(() => ({
  position: 'relative',
  animation: `${floatAndFade} 1.5s linear`,
  textShadow: 'none',
  pointerEvents: 'none',
  right: '50%',
  top: '50%',
  width: '100px',
  fontWeight: 'bold',
  '&.float-warm': {
    animation: `warmFloat 1.4s ease-out`,
  },
  '&.float-cold': {
    animation: `coldShake 1s ease-in-out`,
  },
  '&.float-miss': {
    animation: `missFade 1.1s ease-out`,
  },
  '@keyframes warmFloat': {
    '0%': { opacity: 0, transform: 'translateY(6px) scale(0.98)' },
    '40%': { opacity: 1, transform: 'translateY(-6px) scale(1.02)' },
    '100%': { opacity: 0, transform: 'translateY(-18px) scale(1.06)' },
  },
  '@keyframes coldShake': {
    '0%': { opacity: 0, transform: 'translate(0, 4px)' },
    '20%': { opacity: 1, transform: 'translate(-2px, 0)' },
    '40%': { transform: 'translate(2px, -2px)' },
    '60%': { transform: 'translate(-2px, -4px)' },
    '80%': { transform: 'translate(2px, -6px)' },
    '100%': { opacity: 0, transform: 'translate(0, -8px)' },
  },
  '@keyframes missFade': {
    '0%': { opacity: 0, transform: 'translateY(4px)' },
    '50%': { opacity: 0.8, transform: 'translateY(-2px)' },
    '100%': { opacity: 0, transform: 'translateY(-10px)' },
  },
}))

export default FloatingText
